import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo";
import AlbumsMarketplacePage from "@/components/Marketplace/AlbumsMarketplacePage";
import { marketplaceSearchSchema } from "../-search";

export const Route = createFileRoute("/marketplace/_layout/albums")({
  validateSearch: marketplaceSearchSchema,
  component: AlbumsMarketplacePage,
  head: () =>
    seoHead({
      title: "Buy Albums Direct From Artists | Lutely Marketplace",
      description:
        "Browse albums and singles sold direct by independent artists. Buy once, own forever, and send your money straight to the people who made the music.",
      canonicalPath: "/marketplace/albums",
    }),
});
